/* eslint-disable */

import instance from './frontman';

export const getPayMeans = async (accessToken?: String) => {
    return await instance({
        url: "/billing/pay-means",
        method: "get"
    })
};